import React, { useState, useEffect, useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Gallery from "react-photo-gallery";

import {
  client,
  serverUrl,
  apiEndpoints,
  filesystem_root,
  subdomain,
} from "../../config";
import PostSingle from "../../partials/posts/postSingle";
import CompanyappLoader from "../../partials/companyappLoader";

import { Carousel, Row } from "react-bootstrap";
import { Typography, Button, Dialog, Box } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {
  FullscreenOutlined,
  FullscreenExitOutlined,
} from "@mui/icons-material";

import { getImageDimensions } from "./imageProcessor";

export default function GallerySingle(props) {
  const [post, setPost] = useState(null);
  const params = useParams();
  const [loadedImages, setLoadedImages] = useState(0);
  const [showGallery, setShowGallery] = useState(false);
  const [gallery, setGallery] = useState([]);

  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [showViewer, setShowViewer] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [viewFullscreen, setViewFullscreen] = useState(false);

  const user = useSelector((state) => state).authReducer.user;
  const [searchParams] = useSearchParams();
  const fullscreenRef = useRef(null);

  const hash = searchParams.get("hash");


  useEffect(() => {
    if (gallery.length > 0 && gallery.length === loadedImages) {
      setShowGallery(true);
    }
  }, [gallery, loadedImages]);

  useEffect(() => {
    if (post && post.body) {
      processGallery(post.body);
    }
  },[post]);

  const processGallery = (editorData) => {
    const galleryBlocks = editorData.blocks.filter((block) => block.type === "gallery");
    if(galleryBlocks.length === 0) return;
    const photos = [];
    galleryBlocks.forEach((block) => {
      block.data.images.forEach((item) => {
        photos.push(item);
      });
    });
    setGallery(photos);
  }

  const galleryElement = ({ photo, index }) => {
    let imageSrc = photo.url;

    if (!props.preview) {
      imageSrc = `${filesystem_root}/${subdomain}/gallery/${post.id}/${post.id}/${photo.url}`;
    }

    return (
      <Button
        key={`button-${index}`}
        className="gallery-element"
        style={{
          width: photo.width,
          height: photo.height,
        }}
        onClick={() => {
          setActiveIndex(index);
          setShowViewer(true);
        }}
      >
        <img
          src={imageSrc}
          alt=""
          onLoad={() => setLoadedImages((prevData) => prevData + 1)}
          onError={() => setLoadedImages((prevData) => prevData + 1)}
        />
      </Button>
    );
  };

  const renderGallery = () => {
    return (
      <>
        {!showGallery && (
          <div className="gallery-opacity-loader">
            <CompanyappLoader />
          </div>
        )}
        <div
          className={`gallery-opacity-container ${showGallery ? "show" : ""}`}
        >
          <Gallery
            photos={gallery}
            targetRowHeight={180}
            renderImage={galleryElement}
          />
        </div>
      </>
    );
  };

  const enterFullscreen = () => {
    const element = fullscreenRef.current;

    if (element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        // For Firefox
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        // For Chrome, Safari and Opera
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        // For IE/Edge
        element.msRequestFullscreen();
      }
    }
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  };

  return (
    <PostSingle
      preview={props.preview}
      apiEndpoint={apiEndpoints.gallery}
      entityFavoritesContentType={"gallery"}
      preview={props.preview}
      previewReturnRoute={"/galleries-creator"}
      returnRoute={"/galleries"}
      backBtnText={"Gallery Library"}
      screenClassName={"galleries"}
      v2Bundle={"gallery"}
      logCustomEventType={"Gallery"}
      entityType={"gallery"}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
    >
      {post && (
        <>
          <Row className="gallery-container mt-4">{renderGallery()}</Row>
          <Dialog
            className="gallery-image-viewer"
            maxWidth="lg"
            fullWidth
            open={showViewer}
            onClose={() => {
              setShowViewer(false);
              setViewFullscreen(false);
            }}
            fullScreen
            ref={fullscreenRef}
            // fullScreen={fullScreen}
            // sx={{
            //   "& .MuiPaper-root": !fullScreen ? {
            //     width: '80%',
            //     height: '80%'
            //   } : {}
            // }}
          >
            <Button
              className="close-viewer-btn"
              onClick={() => {
                setShowViewer(false);
                setViewFullscreen(false);
              }}
            >
              <CloseRoundedIcon />
            </Button>
            <Button
              className="fullscreen-viewer-btn"
              onClick={() => {
                if (viewFullscreen) {
                  exitFullscreen();
                  setViewFullscreen(false);
                } else {
                  enterFullscreen();
                  setViewFullscreen(true);
                }
              }}
            >
              {viewFullscreen ? (
                <FullscreenExitOutlined />
              ) : (
                <FullscreenOutlined />
              )}
            </Button>
            <Carousel
              className="image-viewer-carousel"
              activeIndex={activeIndex}
              controls={true}
              indicators={false}
              slide={true}
              onSelect={(index) => setActiveIndex(index)}
              interval={null}
              touch={true}
            >
              {gallery.map((e, i) => {
                let imageSrc = e.url;

                if (!props.preview) {
                  imageSrc = `${filesystem_root}/${subdomain}/gallery/${post.id}/${post.id}/${e.url}`;
                }

                return (
                  <Carousel.Item
                    key={`c-item-${i}`}
                    className="image-viewer-carousel-item"
                  >
                    <Box className="image-item-container">
                      <Box className="image-item-reducer">
                        <img
                          className="image-item"
                          src={imageSrc}
                          alt={e.title}
                          data-description={e.caption}
                        />
                      </Box>
                      <Box className="image-caption-container">
                        <Typography
                          className="image-caption"
                          owner="admin"
                          variant="body2"
                          color="adminText.contrastText"
                          weight="regular"
                          align="center"
                        >
                          {e.caption}
                        </Typography>
                      </Box>
                    </Box>
                  </Carousel.Item>
                );
              })}
            </Carousel>
          </Dialog>
        </>
      )}
    </PostSingle>
  );
}
